import MiniCartItem from 'snippets/mini-cart-item/mini-cart-item'

function MiniCartList({ items, setCart, isFetching, setFetching, hiddenGiftMessage }) {
  return (
    <div className={`flex flex-col px-4 md:px-6 ${!hiddenGiftMessage && 'border-t border-default'}`}>
      {items.map((cartItem) => (
        <MiniCartItem item={cartItem} setCart={setCart} isFetching={isFetching} setFetching={setFetching} />
      ))}
    </div>
  )
}

export default MiniCartList
